import { Configuration, SuppliersApi } from '@/api';
import CustomToast from '@/components/CustomToast';
import PageHeader from '@/components/PageHeader';
import { SupplierCreate, SupplierUpdate } from '@/models/Supplier';
import Breadcrumbs from '@/modules/admin/components/Breadcrumbs';
import SupplierForm from '@/modules/admin/components/SupplierForm';
import { SupplierListPath } from '@/modules/admin/paths';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const SupplierAdd = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  const suppliersApi = new SuppliersApi(new Configuration(auth));

  const handleOnSubmit = async (supplier: SupplierCreate | SupplierUpdate): Promise<void> => {
    try {
      await suppliersApi.createSupplier(supplier as SupplierCreate);

      toast.custom((t) => (
        <CustomToast
          id={t.id}
          message={`Supplier "${supplier.name}" created successfully!`}
          visible={t.visible}
        />
      ));

      navigate(SupplierListPath); // adjust path as needed
    } catch (error) {
      console.error('Failed to create supplier:', error);
    }
  };

  return (
    <>
      <Breadcrumbs />

      <PageHeader title="Create Supplier" />

      <div className="w-full bg-white mx-auto rounded-lg shadow p-6 lg:p-12">
        <SupplierForm onSubmit={handleOnSubmit} />
      </div>
    </>
  );
};

export default SupplierAdd;
